import { ChosenAnswer, IAdobeInteraction, Result } from "@abbvie-epi/common/models";
import { Component, EventEmitter, OnInit, Output } from "@angular/core";
import { Router } from "@angular/router";
import { AnalyticsHelperService } from "../../services/analytics-helper.service";
import { ResultsService } from "../../services/results.service";

@Component({
    selector: "app-results",
    templateUrl: "./results.component.html",
    styleUrls: ["./results.component.scss"]
})
export class ResultsComponent implements OnInit {
    public result: Result | undefined;
    public hasResults: boolean;
    public resultPdf: string;

    public chosenAnswers: ChosenAnswer[] = [];

    @Output() clearResult = new EventEmitter();

    constructor(
        private resultsService: ResultsService,
        private router: Router,
        private analyticsHelper: AnalyticsHelperService
    ) {}

    public ngOnInit() {
        this.getResultStatus();
        this.getChosenAnswers();
        this.getResultPdf();
    }

    private async getResultStatus() {
        this.result = await this.resultsService.getResult();

        if (!this.result) {
            this.hasResults = false;
        } else {
            this.hasResults = true;
        }
    }

    private getChosenAnswers() {
        this.chosenAnswers = this.resultsService.chosenAnswers;
    }

    public startOver(trackingId?: string) {
        if (trackingId) {
            this.analyticsHelper.trackInteraction(trackingId);
        }

        this.resultsService.clearResult();

        this.router.navigateByUrl("/", { skipLocationChange: true }).then(() => {
            this.router.navigate(["screening-tool-landing"], { fragment: "start-screening" });
        });
    }

    public track(id: string): void {
        this.analyticsHelper.trackInteraction(id);
    }

    public trackDownload(): void {
        // pass result pdf link as interaction url
        const analyticsOverride: IAdobeInteraction = {
            link: {
                url: this.resultPdf
            }
        };

        this.analyticsHelper.trackInteraction("results-page-download-summary", analyticsOverride);
    }

    // get pdf paths from id
    private getResultPdf() {
        const resultId: string = this.resultsService.getResultId();
        this.resultPdf = `assets/pdfs/Results-${resultId.toUpperCase()}.pdf`;
    }
}
